import { authInstance, guestInstance } from ".";
import { IEventItem } from "../interfaces/IEventItem";
import { IEventPageResponseModel } from "../interfaces/responses/IEventPageResponseModel";
import { IEventResponseModel } from "../interfaces/responses/IEventResponseModel";

export const createEvent = async (
    eventData: FormData
): Promise<string> => {
    try {
        await authInstance.post('event/create', eventData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return '200';
    } catch (e: any) {
        return e.response?.data?.message || 'Ошибка при создании события';
    }
};

export const getAllEvents = async (): Promise<IEventResponseModel[] | string> => {
    try {
        const response = await guestInstance.get('event/getall');
        return response.data;
    } catch (e: any) {
        return e.response?.data?.message || ['Ошибка при получении событий'];
    }
};

export const getUserEvents = async (
    userId: string
): Promise<IEventItem[] | string> => {
    try {
        const response = await authInstance.get(`event/getUserEvents/${userId}`);
        return response.data;
    } catch (e: any) {
        return e.response?.data?.message || ['Ошибка получения пользователей'];
    }
};

export const getEventByTitle = async (
    title: string
): Promise<IEventResponseModel[] | string[]> => {
    try {
        const response = await guestInstance.get(`event/getByTitle/${title}`);
        return response.data;
    } catch (e: any) {
        return e.response?.data?.errors || ['Ошибка при поиске событий'];
    }
};

export const getEventById = async (
    id: string
): Promise<IEventResponseModel | string> => {
    try {
        const response = await guestInstance.get(`event/getById/${id}`);
        const event = response.data;
        return event;
    } catch (e: any) {
        return e.response?.data?.message || ['Ошибка при получении события'];
    }
};

export const getEventByIdAndDate = async (
    eventId: string,
    dateId?: string
): Promise<IEventPageResponseModel | string> => {
    try {
        const response = await guestInstance.get(`event/getByIdAndDate/${eventId}/${dateId}`);
        const eventData = response.data;

        return eventData;
    } catch (e: any) {
        return e.response?.data?.message || 'Ошибка при получении события';
    }
};

export const updateEvent = async (
    id: string,
    eventData: FormData
): Promise<string> => {
    try {
        await authInstance.put(`event/update/${id}`, eventData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return '200';
    } catch (e: any) {
        return e.response?.data?.message || ['Ошибка при обновлении события'];
    }
};

export const deleteEvent = async (id: string): Promise<string | null> => {
    try {
        await authInstance.delete(`event/delete/${id}`);
        return null;
    } catch (e: any) {
        return e.response?.data?.errors || ['Ошибка при удалении события'];
    }
};
